exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ChangeFormatSettings-module__tooltip-menu___pdMET{display:grid;gap:.75rem}", ""]);

// exports
exports.locals = {
	"tooltip-menu": "ChangeFormatSettings-module__tooltip-menu___pdMET"
};